import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT, READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { ITrainingBatchLevel } from 'src/app/interfaces/training';
import { MappingService, pushToArray } from 'src/app/services/mapping.service';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-add-reading-batch',
  templateUrl: './add-reading-batch.component.html',
  styleUrls: ['./add-reading-batch.component.scss']
})
export class AddReadingBatchComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  form: FormGroup;
  level: AbstractControl;
  tutor: AbstractControl;


  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new batch';
  GENDER: any = GENDERS;
  ITEM: ITrainingBatchLevel;

  LEVEL_LIST: any;
  TUTOR_LIST: any;
  constructor(
    public dialogRef: MatDialogRef<AddReadingBatchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  async ngOnInit() {
    const { ITEM } = this.data;
    this.ITEM = ITEM || null;
    this.form = this.fb.group({
      name: [ITEM ? ITEM.name : null, Validators.compose([Validators.required,])],
      level: [ITEM ? ITEM.levelKey : null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      tutor: [ITEM ? ITEM.tutorKey : GENDERS[0], Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      description: [ITEM ? ITEM.description : null,],
    })
    this.level = this.form.controls['level'];
    this.tutor = this.form.controls['tutor'];
    const LEVEL_LIST = pushToArray(await this.ds.readingBatchLevelRef().get().toPromise())
    const TUTOR_LIST = pushToArray(await this.ds.userMemberListRef(READING_MEMBER_OBJECT.teachers.key).get().toPromise())
    this.LEVEL_LIST = MappingService.autoComplete(this.level, LEVEL_LIST, "order");
    this.TUTOR_LIST = MappingService.autoComplete(this.tutor, TUTOR_LIST, "fullName");

    if (ITEM) {
      this.TITLE = "Edit batch";
      const { levelKey, tutorKey } = ITEM;

      this.form.patchValue({
        level: LEVEL_LIST.filter(m => m.key === levelKey)[0],
        tutor: TUTOR_LIST.filter(m => m.key === tutorKey[0])[0]
      })
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }


  displayItem(item: any): string {
    return item ? item.name || item.fullName : item;
  }
  displayItemFullName(item: any): string {
    return item ? item.fullName : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { description, level, tutor, name } = f;
      const { ITEM } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: ITrainingBatchLevel = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        description, name,
        levelKey: level.key,
        levelRef: this.ds.levelRef().doc(level.key).ref,
        tutorKey: [tutor.key],
        tutorRef: [this.ds.tutorRef().doc(tutor.key).ref],
        level: level,
        tutor: tutor,
      }
      this.store.addItem(COLLECTION_NAME.READING_BATCHES, item, (success, res) => {
        if (success) {
          this.snackBar.open("Batch has been saved successful.", "Done", { duration: 1000 });
          if (!isNew) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.inputEl.nativeElement.focus()
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}